const App = {
    SetBackground: () => {
        $('[setBackground]').each(function() {
            var background = $(this).attr('setBackground')
            $(this).css({
                "background-image": "url(" + background + ")",
                "background-size": "cover",
                "background-position": "center center"
            })
        })
        $('[setBackgroundRepeat]').each(function() {
            var background = $(this).attr('setBackgroundRepeat')
            $(this).css({
                "background-image": "url(" + background + ")",
                "background-repeat": "repeat"
            })
        })
    },
    EqualHeightElement: el => {
        let height = 0;
        let thisHeight = 0;
        $(el).each(function() {
            thisHeight = $(this).height();
            if (thisHeight > height) {
                height = thisHeight;
            }
        });
        $(el).height(height)
    },
    AutoGenerateSelectInMoBile: condition => {
        if (condition.matches) {
            $("[data-nav]").each(function() {
                let idSelect = $(this).attr("data-nav");
                let jIdSelect = "#" + idSelect;
                let optionList = [];
                $(this).find("a").each(function() {
                    let _this = $(this)
                    let selected = false;
                    if (_this.hasClass("selected")) {
                        selected = true;
                    }
                    let option = {
                        url: _this.attr('href'),
                        title: _this.text(),
                        selected: selected
                    }
                    optionList.push(option)
                });
                $(this).parent().append("<select class=\"data-nav\" id=" + idSelect + "></select>");
                $("#" + idSelect).append("<option disabled>Chọn danh mục</option>")
                for (let option of optionList) {
                    if (option.selected === true) {
                        $(jIdSelect).append("<option value=" + option.url + " selected=\"true\">" + option.title + "</option>")
                    } else {
                        $(jIdSelect).append("<option value=" + option.url + ">" + option.title + "</option>")
                    }
                }
                $(this).fadeOut()
            })
            $("body").on("change", ".data-nav", function() {
                let url = $(this).val()
                window.location.assign(url)
            })
        } else {
            $("[data-nav]").fadeIn()
            $("[data-nav]").parent().find(".data-nav").remove()
        }
    },
    AutoGenerateSelectInMoBileOnResize: () => {
        let breakpoint = window.matchMedia("(max-width: 1199.98px)")
        App.AutoGenerateSelectInMoBile(breakpoint);
        breakpoint.addListener(App.AutoGenerateSelectInMoBile)
    },
    GetUrl: () => {
        return window.location.href
    },
    AddUrlToShareButton: () => {
        if ($('.news-detail-social .fb-share-button').length) {
            $('.news-detail-social .fb-share-button a').attr('href', 'https://www.facebook.com/sharer/sharer.php?u=' + App.GetUrl())
        }
    }

}
const Header = {
    ToggleMenuMobile: () => {
        $('.country-header .desktop-wrapper .button-mobile-wrapper').on('click', function() {
            $('.country-header .mobile-wrapper').addClass('active')
            $('.country-header .backdrop-wrapper').addClass('active')
        })
        $('.country-header .mobile-wrapper .button-mobile-wrapper, .country-header .backdrop-wrapper').on('click', function() {
            $('.country-header .mobile-wrapper').removeClass('active')
            $('.country-header .backdrop-wrapper').removeClass('active')
        })
    },
    MobileMapping: () => {
        return {
            "ListPageWrapper": new MappingListener({
                selector: '.country-header .list-page-wrapper',
                mobileWrapper: '.country-header .mobile-wrapper',
                mobileMethod: 'appendTo',
                desktopWrapper: '.country-header .desktop-wrapper .logo-wrapper',
                desktopMethod: 'insertAfter',
                breakpoint: 1025,
            }).watch(),
            "PhoneWrapper": new MappingListener({
                selector: '.country-header .phone-wrapper',
                mobileWrapper: '.country-header .mobile-wrapper',
                mobileMethod: 'appendTo',
                desktopWrapper: '.country-header .desktop-wrapper .list-page-wrapper',
                desktopMethod: 'insertAfter',
                breakpoint: 1025,
            }).watch(),
        }

    },
    Init: () => {

        Header.ToggleMenuMobile()
        Header.MobileMapping()
    }
}
const Slider = {
    HomeBanner: () => {
        return new Swiper('.country-banner .swiper-container', {
            slidesPerView: 1,
            speed: 1500,
            autoplay: {
                delay: 4000
            },
            navigation: {
                nextEl: '.country-banner .swiper-next',
                prevEl: '.country-banner .swiper-prev',
            },
        })
    },
    MaterialSlide: () => {
        return new Swiper('.country-home-2 .swiper-container', {
            slidesPerView: 2,
            speed: 1000,
            autoplay: {
                delay: 3000
            },
        })
    },
    LeaderSlide: () => {
        return new Swiper('.country-introduce-4 .swiper-container', {
            slidesPerView: 3,
            speed: 1000,
            spaceBetween: 20,
            autoplay: {
                delay: 3000
            },
            breakpoints: {
                1025: {
                    slidesPerView: 2
                },
                576: {
                    slidesPerView: 1
                }
            }
        })
    },
    ProductDetailSlide: () => {
        var GalleryThumb = new Swiper('.product-detail-wrapper.active .product-detail-item .detail-thumb-image .swiper-container', {
            spaceBetween: 10,
            slidesPerView: 2,
            direction: 'vertical',
            speed: 1000,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            breakpoints: {
                1025: {
                    direction: 'horizontal'
                }
            }
        })
        let GalleryTop = new Swiper('.product-detail-wrapper.active .product-detail-item .detail-current-image .swiper-container', {
            effect: 'fade',
            thumbs: {
                swiper: GalleryThumb
            },
            speed: 1000,
            autoplay: {
                delay: 3000
            },
            navigation: {
                clickable: true,
                nextEl: '.product-detail-wrapper .detail-thumb-image .swiper-button.swiper-down',
                prevEl: '.product-detail-wrapper .detail-thumb-image .swiper-button.swiper-up'
            }

        });

    },
    RelatedNews: () => {
        return new Swiper('.country-news-detail .swiper-container', {
            slidesPerView: 3,
            speed: 1000,
            spaceBetween: 20,
            autoplay: {
                delay: 3000
            },
            breakpoints: {
                1025: {
                    slidesPerView: 2
                },
                576: {
                    slidesPerView: 1
                }
            }
        })
    },
    HomeCertificates: () => {
        return new Swiper('.country-home-4 .swiper-container', {
            slidesPerView: 4,
            speed: 1000,
            spaceBetween: 20,
            autoplay: {
                delay: 3000
            },
            breakpoints: {
                1025: {
                    slidesPerView: 3
                },
                576: {
                    slidesPerView: 2
                }
            }
        })
    },
    Init: () => {
        Slider.HomeBanner()
        Slider.HomeCertificates()
        Slider.MaterialSlide()
        Slider.LeaderSlide()
        Slider.RelatedNews()
    }
}
const Page = {
    ProductFilter: () => {
        $('.product-filter-wrapper .product-filter-group-heading').on('click', function() {
            if ($(this).siblings('.product-filter-group-list').is(':hidden')) {
                $(this).addClass('active')
                $(this).siblings('.product-filter-group-list').slideDown()
            } else {
                $(this).removeClass('active')
                $(this).siblings('.product-filter-group-list').slideUp()
            }

        })
        $('.product-filter-wrapper .product-filter-group-list a.active').parent().siblings('.product-filter-group-heading').trigger('click')
    },
    CreateTitleOnBreadcrumb: () => {
        let e = $('.breadcrumb-section ol.breadcrumb li:last-child a').text()
        $('.breadcrumb-section h1').text(e)
    },
    DetailModel: () => {
        $('[data-detail]').on('click', function() {
            let id = $(this).attr('data-detail')
                // $('.product-detail-wrapper').fadeIn()
            $('#' + id).addClass('active')
            Slider.ProductDetailSlide()
        })
        $('.product-detail-wrapper .close-detail').on('click', function() {
            $(this).parents('.product-detail-wrapper').removeClass('active')
                // $(this).parents('.product-detail-item').fadeOut()
        })
    },
    AjaxLoad: () => {
        $(document).on('click', '.News-Page .ModulePager', function(e) {
            e.preventDefault()
            let param = {
                url: '',
                $data: ''
            }
            param.url = $(this).attr('href')
            $.ajax({
                url: param.url,
                type: 'POST',
                data: {
                    isajax: true
                },
                beforeSend: () => {
                    $('.loading-wrapper').addClass('active')
                    setTimeout(() => {
                        $('.loading-wrapper').removeClass('active')
                    }, 500);
                },
                success: data => {

                    param.$data = $(data)
                    setTimeout(() => {
                        $('.News-Page .country-news').html(param.$data.find('.country-news').html());
                        $('.News-Page .modulepager .pagination').html(param.$data.find('.pagination').html());
                    }, 200);
                },
                complete: () => {
                    if (param.url != window.location) {
                        window.history.pushState({ path: param.url }, '', param.url);
                    }
                }
            })
            return
        })

    },
    Init: () => {
        Page.ProductFilter()
        Page.DetailModel()
        Page.CreateTitleOnBreadcrumb()
        Page.AjaxLoad()
    }
}

App.AddUrlToShareButton()
$(document).ready(function() {
    Header.Init()
    Slider.Init()
    Page.Init()
    App.SetBackground()

    if ($('#home-popup').length) {
        $('#home-popup').trigger('click')
    }
    $('[data-fancybox]').fancybox({
            thumbs: {
                autoStart: true
            },
            buttons: [
                "zoom",
                //"share",
                "slideShow",
                //"fullScreen",
                //"download",
                "thumbs",
                "close"
            ],
        })
        // App.EqualHeightElement('.product-list-wrapper .product-item figure figcaption h5')
    $('.country-home-6 .image a img').each(function() {
        let i = $(this).attr('src')
        $(this).parent().attr('href', i)
    })
    $('a').removeAttr('title')
})
$(document).load(function() {
    App.EqualHeightElement('.country-home-4 figure figcaption')
    App.EqualHeightElement('.country-home-6 .part-list .image')
    App.EqualHeightElement('.product-item figure .image')
    App.EqualHeightElement('.gallery-item.part-item')
    App.EqualHeightElement('.catalogue-item .image')
})